import { c, classy } from '@onfido/castor';
import { Icon } from '@onfido/castor-react';
import React, { useEffect } from 'react';
import { useCustomSelect } from './useCustomSelect';
export function CustomOption({ children, className, disabled, hidden, value: optionValue, onClick, onKeyUp, ...restProps }) {
    const { initialize, name, select, value } = useCustomSelect();
    useEffect(() => initialize(children, optionValue), []);
    if (hidden)
        return null;
    const selectOption = () => disabled || select(children, optionValue);
    const selected = value == optionValue;
    return (React.createElement("label", { ...restProps, className: classy(c('select-option'), className), onClick: (event) => {
            // moving through options with arrow keys (onChange) will trigger
            // onClick events here, but we don't want to select then, so we filter
            // only events that have detail, which are triggered by mouse clicks
            if (event.detail)
                selectOption();
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
        }, onKeyUp: (event) => {
            if (selectOptionKeys.has(event.key))
                selectOption();
            onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(event);
        } },
        React.createElement("input", { className: classy(c('select-option-input')), checked: selected, disabled: disabled, name: name, readOnly: true, type: "radio" }),
        React.createElement("span", { className: classy(c('select-option-content')) }, children),
        selected && !disabled && (React.createElement(Icon, { className: classy(c('select-option-icon')), "aria-hidden": "true", name: "check" }))));
}
const selectOptionKeys = new Set([' ', 'Enter']);
//# sourceMappingURL=custom-option.js.map